import Chip, { chipClasses } from '@mui/material/Chip'
import { Theme } from '@mui/material/styles'
import * as React from 'react'
import { useCallback } from 'react'
import { IFilterChipProps, IFilterSet } from '../typings'
import { FilterChipLabel } from './FilterChipLabel'
import { useData } from './hooks'

export function FilterChip<U, T extends IFilterSet<U>>(
  props: IFilterChipProps,
) {
  const { filterId, entityType, onDeleteChip, salesTeamCount } = props

  const { mainLabel, subLabel, modeLabel } = useData<U, T>(
    filterId,
    entityType,
    salesTeamCount,
  )

  const onDelete = useCallback(
    () => onDeleteChip(filterId),
    [onDeleteChip, filterId],
  )

  return (
    <Chip
      label={
        <FilterChipLabel
          mainLabel={mainLabel}
          subLabel={subLabel}
          modeLabel={modeLabel}
        />
      }
      data-test-id={`filter-chip-${filterId}`}
      onDelete={onDelete}
      variant="outlined"
      sx={{
        border: 'none',
        color: '#19305A',
        lineHeight: '20px',
        paddingBottom: (theme: Theme) => theme.spacing(2),
        [`& .${chipClasses.deleteIcon}`]: {
          color: '#19305A',
          marginRight: (theme: Theme) => theme.spacing(0),
        },
      }}
    />
  )
}
